import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Fab from '@mui/material/Fab';
import Icon from '@mui/material/Icon';
import { primary } from '../../utils/brandColors';

const StatusBadgeComponent = ({
  icon,
  // eslint-disable-next-line no-unused-vars
  iconColor,
  label,
  size,
  margin,
  mini,
}) => {
  if (mini) {
    return (
      <Icon
        style={{
          color: primary[500],
          fontSize: '20px',
        }}
      >
        {icon}
      </Icon>
    );
  }
  return (
    <span
      style={
        margin
          ? { margin: '0 5px 5px 0' }
          : {}
      }
    >
      <Fab
        style={{
          color: primary[500],
          boxShadow: 'none',
          width: size,
          height: size,
          backgroundColor: '#F2F2F2',
        }}
      >
        <Icon>{icon}</Icon>
      </Fab>
      {
        !!label
          && (
            <Typography
              variant="subtitle1"
              gutterBottom
              style={{
                display: 'inline',
                marginLeft: 10,
              }}
            >
              {label}
            </Typography>
          )
      }
    </span>
  );
};

StatusBadgeComponent.propTypes = {
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.number,
  margin: PropTypes.bool,
  mini: PropTypes.bool,
};

StatusBadgeComponent.defaultProps = {
  icon: 'search',
  iconColor: '#ffffff',
  label: '',
  size: 40,
  margin: false,
  mini: false,
};

export default StatusBadgeComponent;
